import customDecodeURIComponent from "../customDecodeURIComponent";
var getCSRFToken = function getCSRFToken() {
  var cookies = {
    csrftoken: undefined
  };
  if (document.cookie && document.cookie !== '') {
    document.cookie.split(';').forEach(function (c) {
      var m = c.trim().match(/(\w+)=(.*)/);
      if (m) {
        // @ts-ignore
        cookies[m[1]] = customDecodeURIComponent(m[2]);
      }
    });
  }
  return cookies.csrftoken;
};
export default getCSRFToken;